var viewer_caption_rtlignore_default = {
  "fontElementMap": "UQyPa",
  "imageCaption": "yqGB-"
};
export {
  viewer_caption_rtlignore_default as default
};
//# sourceMappingURL=viewer-caption.rtlignore-scss.js.map
